import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";
import {pluralize} from "@pg-mono/string-utils";
import {propertyOffer} from "@pg-mono/string-utils";

import {RegionType} from "../../region/types/RegionType";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital} from "../helpers/OfferType";
import {OfferType} from "../types/OfferType";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

export interface IProps {
    region: {
        name: string;
        name_declension_where: string;
        slug: string;
        stats: {
            properties_all_rooms_ranges: Record<number, number>;
            properties_flats_rooms_ranges: Record<string, number>;
            properties_houses_rooms_ranges: Record<number, number>;
            properties_commercials_rooms_ranges: Record<number, number>;
            properties_all_count_for_sale: number;
            properties_flats_count_for_sale: number;
            properties_houses_count_for_sale: number;
            properties_commercials_count_for_sale: number;
        } | null;
        type: RegionType;
    };
    offerType: OfferType | null;
    oneToFiveRoomsRanges: Record<number, number>;
}

const getLinkText = (rooms: number, offerType: OfferType | null, regionName: string, amount: number) => {
    const moreRooms = rooms >= 5 ? " i więcej" : "";
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    if (offerType === OfferType.FLAT && rooms === 1) {
        return `Kawalerki ${regionName}`;
    }

    if (offerType && offerType !== OfferType.COMMERCIAL) {
        return `${offerType ? getOfferTypeNamePluralCapital(offerType) : "Oferty"}  ${rooms} ${roomsPluralize(rooms)}
                            ${regionName}`;
    }

    return `${offerType ? getOfferTypeNamePluralCapital(offerType) : "Oferty"}  ${rooms}-pokojowe${moreRooms}
                          (${amount} ${propertyOffer.nominative(amount)})`;
};

export const OfferLocationLinksRegionRooms = React.memo((props: IProps) => {
    const {region, offerType, oneToFiveRoomsRanges} = props;

    return (
        <>
            {Object.entries(oneToFiveRoomsRanges).map(([roomsStr, amount]) => {
                const rooms = parseInt(roomsStr, 10);
                const regionFriendlySlug = offerUrlBuilder({
                    type: offerType,
                    region: region.slug,
                    rooms_0: rooms,
                    rooms_1: rooms
                }).friendlySlug;
                const link = rpAppLink.offer.listFriendly({friendlySlug: regionFriendlySlug});
                const linkText = getLinkText(rooms, offerType, region.name, amount);

                return <OfferLocationLinksItem disableSelfLinking linkText={linkText} url={link} key={link} />;
            })}
        </>
    );
});
import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";
import {pluralize} from "@pg-mono/string-utils";
import {propertyOffer} from "@pg-mono/string-utils";

import {RegionType} from "../../region/types/RegionType";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital} from "../helpers/OfferType";
import {OfferType} from "../types/OfferType";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

export interface IProps {
    region: {
        name: string;
        name_declension_where: string;
        slug: string;
        stats: {
            properties_all_rooms_ranges: Record<number, number>;
            properties_flats_rooms_ranges: Record<string, number>;
            properties_houses_rooms_ranges: Record<number, number>;
            properties_commercials_rooms_ranges: Record<number, number>;
            properties_all_count_for_sale: number;
            properties_flats_count_for_sale: number;
            properties_houses_count_for_sale: number;
            properties_commercials_count_for_sale: number;
        } | null;
        type: RegionType;
    };
    offerType: OfferType | null;
    oneToFiveRoomsRanges: Record<number, number>;
}

const getLinkText = (rooms: number, offerType: OfferType | null, regionName: string, amount: number) => {
    const moreRooms = rooms >= 5 ? " i więcej" : "";
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    if (offerType === OfferType.FLAT && rooms === 1) {
        return `Kawalerki ${regionName}`;
    }

    if (offerType && offerType !== OfferType.COMMERCIAL) {
        return `${offerType ? getOfferTypeNamePluralCapital(offerType) : "Oferty"}  ${rooms} ${roomsPluralize(rooms)}
                            ${regionName}`;
    }

    return `${offerType ? getOfferTypeNamePluralCapital(offerType) : "Oferty"}  ${rooms}-pokojowe${moreRooms}
                          (${amount} ${propertyOffer.nominative(amount)})`;
};

export const OfferLocationLinksRegionRooms = React.memo((props: IProps) => {
    const {region, offerType, oneToFiveRoomsRanges} = props;

    return (
        <>
            {Object.entries(oneToFiveRoomsRanges).map(([roomsStr, amount]) => {
                const rooms = parseInt(roomsStr, 10);
                const regionFriendlySlug = offerUrlBuilder({
                    type: offerType,
                    region: region.slug,
                    rooms_0: rooms,
                    rooms_1: rooms
                }).friendlySlug;
                const link = rpAppLink.offer.listFriendly({friendlySlug: regionFriendlySlug});
                const linkText = getLinkText(rooms, offerType, region.name, amount);

                return <OfferLocationLinksItem disableSelfLinking linkText={linkText} url={link} key={link} />;
            })}
        </>
    );
});
